import icon from "../../assets/license-plate.svg";
import type { Property } from "../../types";

export const licensePlateRecognition: Property = {
  id: "licensePlateRecognition",
  title: "licensePlateRecognition.title",
  icon,
};
